import { IconButton, Typography } from "@mui/material";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import React, { MouseEvent } from "react";

interface IDraggableNameContainerProps {
    divClassName: string;
    floatingClassName: string;
    divStyle: React.CSSProperties;
    name: string;
    nameClassName: string;
    iconClassName: string;
    onMouseDown?: () => void;
    onMouseMove: (e: MouseEvent) => void;
}

const DraggableNameContainer: React.FC<IDraggableNameContainerProps> = ({
    divClassName,
    floatingClassName,
    divStyle,
    name,
    nameClassName,
    iconClassName,
    onMouseDown,
    onMouseMove
}) => {
    return <div 
        className={`${divClassName} ${floatingClassName}`}
        style={{...divStyle}}
    >
        <IconButton onMouseDown={onMouseDown} onMouseMove={onMouseMove}>
            <DragIndicatorIcon className={iconClassName}/>
        </IconButton>
        <Typography 
            className={nameClassName}
            sx={{ WebkitLineClamp: 3 }}
        >
            {name}
        </Typography>
    </div>;
};

export default DraggableNameContainer;
